import { getSeparators, normalizeNumber } from '../../../../../utils/number';

// TODO: Write a unit test
export const appendDecimalPart = (raw: string, formatted: string): string => {
  const { decimal } = getSeparators();
  if (raw.includes(decimal)) {
    const wholeNumberPart = formatted.split(decimal)[0];
    const decimalPart = normalizeNumber(raw).split('.')[1].substring(0, 2);
    const result = `${wholeNumberPart}${decimal}${decimalPart}`;
    return result;
  }
  return formatted;
};
